import {onClick} from '../abstract/helpers.js';

export class Popup {
  constructor() {
    if(document.querySelector('.popup')) {
      
      var open_popup = document.querySelectorAll('.open-popup');
      open_popup.forEach(el => {

        onClick(el, function (e) {
          e.preventDefault();
          document.querySelector('.popup').classList.add('block');
          setTimeout(function() {
            document.querySelector('.popup').classList.add('open');
          }, 10);
        }.bind(this));

      });

      onClick(document.querySelector('.popup .modal .close'), function (e) {
        e.preventDefault();
        
        document.querySelector('.popup').classList.remove('open');
        setTimeout(function() {
          document.querySelector('.popup').classList.remove('block');
        }, 350);
      }.bind(this));

    }
  }
}
